module.exports = __webpack_public_path__ + "static/media/iconVideoStepHorizontal.1cb713da.svg";